const comA2 = {
	length: { min: 2, max: 2 },
	payload: [
		{ length: 1, name: "código", type: "bytes", description: "Código de configuración (1 byte).", pad: "00" },
		{ length: 1, name: "msg", description: "Código del mensaje solicitado. Valores: 'CD' o 'CE'. Tamaño: 1 byte.", type: "string", values: ["CD", "CE"], pad: "00" },
	],
};

export default comA2;